import { useAppContext } from '../../../../contexts/auth';
import MyModal from '../../../Modal';
import AIChat, { ChatMessage } from './components/AiChat';

interface AIModalProps {
  handleAiMessage: (message: string) => void;
  aiChatHistory: ChatMessage[];
  isAiLoading: boolean;
  setAiModalShow: (show: boolean) => void;
  aiModalShow: boolean;
  streamingText?: string;
  onStreamingDone?: () => void;
}

export default function AIModal({
  handleAiMessage,
  aiChatHistory,
  isAiLoading,
  setAiModalShow,
  aiModalShow,
  streamingText,
  onStreamingDone,
}: AIModalProps) {
  const { isDifferentSubdomain } = useAppContext();

  return (
    <MyModal
      title=""
      closeButtonLabel="Fechar"
      modalBody={(
        <AIChat
          onSendMessage={handleAiMessage}
          history={aiChatHistory}
          isLoading={isAiLoading}
          streamingText={streamingText}
          onStreamingDone={onStreamingDone}
          isDifferentSubdomain={isDifferentSubdomain}
          onClose={() => setAiModalShow(false)}
        />
      )}
      onClose={() => setAiModalShow(false)}
      show={aiModalShow}
      size="xl"
      onlyBody
    />
  );
}
